import Vue from 'vue'

import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element from 'element-ui'
import './styles/element-variables.scss'
import enLang from 'element-ui/lib/locale/lang/en'// 如果使用中文语言包请默认支持，无需额外引入，请删除该依赖

import './styles/index.scss' // global css
import './styles/mixin.scss' // global css
import '@/styles/variables.scss'
import App from './App'
import store from './store'
import router from './router'



import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'

Vue.use(VueVideoPlayer)

import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)

import VueIntro from 'vue-introjs'
Vue.use(VueIntro);
import 'intro.js/introjs.css';
if (process.env.NODE_ENV === 'production') {
}
Vue.use(Element, {
  size: Cookies.get('size') || 'medium' // set element-ui default size
})

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
   mounted () {
      document.dispatchEvent(new Event('render-event'))
    },
  store,
  render: h => h(App)
})


